<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">{{ title }}</span>
    </h2>
    <breadcrumb
      firstName="药品管理"
      :second-name="title"
      :custom-path="'/drugsManagement?tab=prescription'"
    ></breadcrumb>

    <el-card>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="left" hide-required-asterisk>
        <el-form-item>
          <template #label>
            <span>医保药品代码</span>
            <span v-if="mode === 'edit'" style="color: #f56c6c; margin-left: 4px">*</span>
          </template>
          <el-input v-model="drugDetail.medicalInsuranceCode" disabled></el-input>
        </el-form-item>
        <el-form-item prop="barcode">
          <template #label>
            <span>药品条形码</span>
            <span v-if="mode === 'edit'" style="color: #f56c6c; margin-left: 4px">*</span>
          </template>
          <el-input
            v-model="form.barcode"
            :disabled="mode === 'view'"
            :placeholder="mode === 'view' ? '' : '请输入药品条形码，多个条形码用英文逗号分隔，最多20个'"
            @input="handleBarcodeInput"
            @blur="validateBarcode"
          ></el-input>
          <div class="barcode-tips" v-if="mode === 'edit'">
            <span>支持多个条形码，用英文逗号分隔，每个条形码只能包含数字，最多20个条形码</span>
            <span v-if="barcodeError" style="color: #f56c6c; margin-left: 12px">{{ barcodeError }}</span>
          </div>
        </el-form-item>
        <el-form-item label="药品通用名">
          <el-input v-model="drugDetail.drugName" disabled></el-input>
        </el-form-item>
        <el-form-item label="药品规格">
          <el-input v-model="drugDetail.spec" disabled></el-input>
        </el-form-item>
        <el-form-item label="生产厂家">
          <el-input v-model="drugDetail.drugEnterprise" disabled></el-input>
        </el-form-item>
        <el-form-item label="批准文号">
          <el-input v-model="drugDetail.approvalNumber" disabled></el-input>
        </el-form-item>
        <el-form-item label="包装单位">
          <el-input v-model="drugDetail.unit" disabled></el-input>
        </el-form-item>
        <el-form-item label="用法">
          <el-input v-model="drugDetail.drugUsage" disabled></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-tag :type="drugDetail.drugStatus === 0 ? 'success' : 'danger'">
            {{ drugDetail.drugStatus === 0 ? '生效中' : '已失效' }}
          </el-tag>
        </el-form-item>
        <el-form-item label="更新时间">
          <el-input v-model="drugDetail.modifiedTime" disabled></el-input>
        </el-form-item>
        <el-form-item v-if="mode === 'edit'">
          <el-button class="btn" type="primary" @click="submit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb';
import Fetch from '@/api';

const adaptDrugUsage = drugUsageList => {
  return drugUsageList.reduce((drugUsageObj, drugUsage) => {
    const obj = drugUsage.children.reduce((childrenObj, usage) => {
      childrenObj[usage.value] = drugUsage.value;
      return childrenObj;
    }, {});
    return { ...drugUsageObj, ...obj };
  }, {});
};

export default {
  name: 'clinicEditor',
  components: {
    breadcrumb
  },
  data() {
    return {
      title: '',
      drugDetail: {
        medicalInsuranceCode: '',
        drugName: '',
        barcode: '',
        spec: '',
        drugEnterprise: '',
        approvalNumber: '',
        unit: '',
        drugUsage: '',
        drugStatus: 0,
        drugCode: '',
        modifiedTime: ''
      },
      form: {
        barcode: ''
      },
      rules: {
        barcode: [
          { required: true, message: '请输入药品条形码', trigger: 'blur' },
          { validator: this.validateBarcodeRule, trigger: 'blur' }
        ]
      },
      mode: '',
      isEdit: false,
      barcodeError: ''
    };
  },

  created() {
    this.setTitle();
    window.addEventListener('beforeunload', this.refreshHint);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.refreshHint);
  },
  mounted() {
    this.initDrugDetail();
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEdit) {
      setTimeout(() => {
        this.confirmLeave()
          .then(() => {
            return false;
          })
          .catch(() => {
            next();
          });
      });
    } else {
      next();
    }
  },
  methods: {
    setTitle() {
      const { type } = this.$route.params;
      const titleMap = {
        edit: '门统医保药品编辑',
        view: '门统医保药品查看'
      };

      this.title = titleMap[type];
      this.mode = type;
    },
    change(key, val) {
      if (this.mode === 'edit') {
        this.isEdit = true;
        this.$set(this.form, key, val);
      }
    },
    // 验证条形码规则
    validateBarcodeRule(rule, value, callback) {
      // 供el-form校验用
      this._validateBarcode(value, callback);
    },
    validateBarcode() {
      // 实时校验并显示错误
      this._validateBarcode(this.form.barcode, err => {
        this.barcodeError = err ? err.message || err : '';
      });
    },
    handleBarcodeInput(e) {
      // 只允许输入数字和英文逗号
      let val = e;
      if (e && e.target) val = e.target.value;
      // 只保留数字和英文逗号
      val = val.replace(/[^\d,]/g, '');
      // 不能以逗号开头
      val = val.replace(/^,+/, '');
      // 不能连续逗号
      val = val.replace(/,+/g, ',');
      // 限制逗号最多19个（即最多20个条形码）
      let commaCount = (val.match(/,/g) || []).length;
      if (commaCount > 19) {
        // 截断到第20个条形码
        let arr = val.split(',');
        val = arr.slice(0, 20).join(',');
      }
      if (val !== this.form.barcode) {
        this.form.barcode = val;
      }
      this.validateBarcode();
    },
    _validateBarcode(value, callback) {
      if (!value) {
        callback(new Error('请输入药品条形码'));
        return;
      }
      // 分割条形码，允许结尾有逗号
      const barcodes = value
        .split(',')
        .map(barcode => barcode.trim())
        .filter(barcode => barcode.length > 0);
      if (barcodes.length > 20) {
        callback(new Error('最多只能输入20个条形码'));
        return;
      }
      for (let i = 0; i < barcodes.length; i++) {
        const barcode = barcodes[i];
        if (!/^\d+$/.test(barcode)) {
          callback(new Error(`第${i + 1}个条形码只能包含数字`));
          return;
        }
      }
      callback();
    },
    async initDrugDetail() {
      const { medicalInsuranceCode } = this.$route.query;

      if (medicalInsuranceCode) {
        try {
          const drugDetail = await Fetch.queryCompanyMedicalDrugDetail({ medicalInsuranceCode });
          this.drugDetail = {
            medicalInsuranceCode: drugDetail.medicalInsuranceCode,
            drugName: drugDetail.drugName,
            barcode: drugDetail.barcode,
            spec: drugDetail.spec,
            drugEnterprise: drugDetail.drugEnterprise,
            approvalNumber: drugDetail.approvalNumber,
            unit: drugDetail.unit,
            drugUsage: drugDetail.drugUsage,
            drugStatus: drugDetail.drugStatus,
            drugCode: drugDetail.drugCode,
            modifiedTime: drugDetail.modifiedTime
          };

          // 无论是查看还是编辑模式，都需要设置条形码值
          this.form.barcode = this.drugDetail.barcode;
        } catch (error) {
          console.error('获取药品详情失败:', error);
          this.$message.error('获取药品详情失败');
        }
      }
    },

    confirmLeave() {
      return this.$confirm('信息未提交，离开将丢失已有信息', '信息未提交', {
        confirmButtonText: '返回提交',
        cancelButtonText: '仍要放弃',
        customClass: 'confirm',
        distinguishCancelAndClose: true,
        center: true
      });
    },
    refreshHint(e) {
      if (this.isEdit) {
        e.returnValue = '';
      }
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const { barcode } = this.form;
          const { medicalInsuranceCode } = this.drugDetail;

          return Fetch.modifyMedicalDrug({
            medicalInsuranceCode,
            barcode
          }).then(async () => {
            await this.$alert('提交成功', '提示', {
              confirmButtonText: '我知道了',
              center: true,
              alignFooter: 'center'
            });

            this.isEdit = false;
            this.$router.push('/drugsManagement?tab=prescription');
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  width: 174px;
}

.barcode-tips {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}
</style>
